module.exports = __webpack_public_path__ + "img/illus-download.4eb3d4bb.png";